import styled from "styled-components";
import {
  Space,
  Button as AntButton,
  Form as AntForm,
  Input as AntInput,
} from "antd";

export const RootContainer = styled.div`
  padding-top: 16px;
  .ant-form {
    margin-top: 22px;

    @media screen and (max-width: 375px) {
      min-height: calc(100vh - 398px);
    }

    @media screen and (max-width: 325px) {
      min-height: calc(100vh - 389px);
    }

    .ant-form-item-label {
      text-align: center;
    }
    .ant-form-item-label label {
      color: #004f9c !important;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .ant-input {
    padding-left: 20px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #000000;
    background: #fff;
    border: 1px solid #0095da !important;
    border-radius: 26px !important;

    ::placeholder {
      color: #dadada !important;
    }
  }

  .float-label label {
    color: #c21c05;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const InfoBox = styled(Space).attrs({
  direction: "vertical",
})`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img.attrs({
  alt: "icon",
})`
  width: 64px;
  margin-bottom: 6px;
  border-radius: 8px;
`;

export const Text = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #464646;

  @media screen and (max-width: 345px) {
    font-size: 13px;
  }

  @media screen and (max-width: 320px) {
    font-size: 12px;
  }
`;

export const BoldText = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #71207c;
`;

export const GroupContainer = styled.div`
  background: #fff;
  padding: 16px;
  border-radius: 16px 16px 0px 0px;

  @media screen and (max-width: 325px) {
    .ant-col {
      padding-left: 3px !important;
      padding-right: 3px !important;
    }
  }
`;

export const Item = styled.div`
  padding: 12px;
  border-radius: 26px;
  border: 1px solid #0095DA;
  background: ${(props) => (props.selected === "true" ? "#0095DA" : "#E1F0FF")};
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 20px;

  ${Text} {
    flex: 1;
    color: ${(props) => (props.selected === "true" ? "#FFF" : "#000")};
    text-align: center;
  }

  @media screen and (max-width: 375px) {
    padding: 8px;

    ${Text} {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 325px) {
    padding: 8px;

    ${Text} {
      font-size: 10px;
    }
  }
`;

export const HelperText = styled.div`
  padding-top: 6px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #949393;
  width: 100%;
  text-align: center;

  @media screen and (max-width: 345px) {
    font-size: 11px;
  }

  @media screen and (max-width: 320px) {
    font-size: 10px;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin: auto 16px;

  .ant-btn {
    height: 52px;
    margin-top: 24px;
  }
`;

export const Box = styled(Space).attrs({
  size: "middle",
})`
  margin-right: -36px;
  align-items: center;

  .anticon {
    font-size: 20px;
    cursor: pointer;
  }
`;

export const FormContainer = styled.div`
  background: #fff;
  padding: 16px;
`;

export const ContinueButton = styled(AntButton)`
  color: ${(props) =>
    props.amount ? `#6D1304 !important` : "#FFF !important"};
`;

export const Form = styled(AntForm)`
  width: 100%;
  margin-top: 0px !important;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-required {
    padding-left: 10px;
    color: #817774 !important;
  }

  input {
    border: 1px solid #dfdfdf;
    border-radius: 12px;
    background: #f2f1f0;
    color: #342309 !important;
    :hover,
    :focus {
      border: 1px solid #dfdfdf;
    }
    ::placeholder {
      color: #342309;
    }
  }

  input[type="text"],
  input[type="number"] {
    height: 52px;
  }

  input[type="password"] {
    height: 40px;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const CustomAmountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0095DA;
  border-radius: 26px;
  margin: 0px 16px;
  padding: 4px;
`;

export const CustomAmountTitle = styled.div`
  color: #FFF;
  font-size: 14px;
  font-weight: 400;
  padding: 0px 4px;
`;